import React, { Fragment } from 'react';
import { Intro, AccordionGroup, Voiceover } from 'dea-core';
import img1 from '../../assets/images/U1-T1-04A.svg';
import img2 from '../../assets/images/U1-T1-04B.svg';
import img3 from '../../assets/images/U1-T1-04C.svg';
import voAudio from '../../assets/vo/Opioid-M-One-05-NEW.mp3';

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript:
    'Before we learn about key variables that have led to the current opioid epidemic, let’s define what' +
    ' opioids are. To do this, expand each section below.'
};

const data = [
  {
    title: 'Opioids are a class of drugs.',
    content: (
      <Fragment>
        <img src={img1} alt="opioids are a class of drugs" />
        <p>
          Prescription opioids include morphine, oxycodone (Percocet),
          hydrocodone (Vicodin), codeine, and fentanyl.
        </p>
      </Fragment>
    )
  },
  {
    title: 'How do they work?',
    content: (
      <Fragment>
        <img src={img2} alt="How do opioids work?" />
        <p>
          Opioids act by stimulating the brain’s own opioid system and flooding
          it with dopamine – the chemical that transmits feel good and
          pleasurable signals in your brain.
        </p>
      </Fragment>
    )
  },
  {
    title: 'Where do they work?',
    content: (
      <Fragment>
        <img src={img3} alt="Where do opioids work?" />
        <p>
          Opioids work in the areas of the brain that are involved in pain
          perception and mood regulation.
        </p>
      </Fragment>
    )
  }
];

export default {
  title: 'What are Opioids?',
  path: '/explain/what-are-opioids',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="What are Opioids?"
        direction="Click to expand each section."
      />
      <AccordionGroup data={data} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/explain/WhatAreOpioids.js